<template>
  <v-btn
    icon
    color="info"
    title="Editar"
    :to="{ path: `/clientes/${cliente.matricula}` }"
    :large="large"
    :disabled="lista_itens.length > 0"
    ><v-icon>mdi-pencil</v-icon></v-btn
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    cliente: Object,
    large: Boolean,
  },
  computed: {
    ...mapState("insumos", ["lista_itens"]),
  },
};
</script>

<style>
</style>